import React from 'react'
import img6 from '../../img/img6.JPG'
import '../Projects.css';


function Project6() {

    return (
        <>

<div className='container-projects'>
                <img src={img6} />
                <div className='project-description'>
                    <h2 className='titulo-projects'>Renovation </h2>
                    The construction of an internal staircase for the family residence "Casa de los Gómez" was undertaken to enhance accessibility and functionality within the home, while adding an aesthetic and structural element that would improve the distribution of interior space. This project involved installing a new staircase to facilitate safe and comfortable movement between different levels of the house.<br></br><br></br>

                    <h1>Renovation Details:</h1>
                    <h1>Initial Evaluation and Planning:</h1><br></br>
                    Space Inspection: A detailed evaluation of the designated area for the staircase was conducted, taking into account floor-to-floor height, existing architectural design, and safety requirements.<br></br><br></br>
                    Design and Specifications: In collaboration with the homeowners, a customized design was developed to meet both functional and aesthetic needs of the home. Material options such as wood, concrete, or metal were discussed, alongside considerations for style and integration with interior decor.
                    
                </div>
            </div>
        </>
    )



}

export default Project6